import Vue from 'vue'
import component from './template'

Vue.component('routes-events-bus-stop-pickup-times-dialog', component)
